import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paymentMethodSelect", "transferReceiptSection"]

  paymentMethodChanged() {
    const method = this.paymentMethodSelectTarget.value
    if (this.hasTransferReceiptSectionTarget) {
      this.transferReceiptSectionTarget.style.display = method === 'wire' ? 'block' : 'none'
    }
  }
}
